import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonService } from 'src/app/@shared/services/common.service';
import { environment } from 'src/environments/environment';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller, Swiper } from 'swiper';
import { LoginPageComponent } from '../login-page/login-page.component';
import { tawkScript } from 'src/app/@shared/javascript/script';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller]);


@Component({
  selector: 'app-home-freeplay',
  templateUrl: './home-freeplay.component.html',
  styleUrls: ['./home-freeplay.component.css']
})
export class HomeFreeplayComponent implements OnInit {
  public env = environment;
  modalRef!: BsModalRef;
  constructor(public _common: CommonService, private modalService: BsModalService) { }

  ngOnInit(): void {

    if(this.env.host.tawkScriptSrc != '') {
      tawkScript();
    }

    const mobileNavShow = document.querySelector('.mobile-nav-show') as any;
    const mobileNavHide = document.querySelector('.mobile-nav-hide') as any;

    document.querySelectorAll('.mobile-nav-toggle').forEach(el => {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        let body = document.querySelector('body') as any
        body.classList.toggle('mobile-nav-active');
        mobileNavShow.classList.toggle('d-none');
        mobileNavHide.classList.toggle('d-none');
      })
    });

    document.querySelectorAll('#navbar a').forEach((navbarlink: any) => {

      if (!navbarlink.hash) return;

      let section = document.querySelector(navbarlink.hash);
      if (!section) return;

      navbarlink.addEventListener('click', () => {
        if (document.querySelector('.mobile-nav-active')) {
          let body = document.querySelector('body') as any
          body.classList.toggle('mobile-nav-active');
          mobileNavShow.classList.toggle('d-none');
          mobileNavHide.classList.toggle('d-none');
        }
      });

    });

    var swiper = new Swiper(".mySlider", {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      initialSlide: 2,
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 0,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });

    var swiper1 = new Swiper(".favSwiperOne", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 1,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    var swiper2 = new Swiper(".favmobile", {
      slidesPerView: 1.5,
      centeredSlides: false,
      slidesPerGroupSkip: 1,
      spaceBetween: 10,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 1.5,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      }
    });

    var swiper3 = new Swiper(".featuredSwiper", {
      slidesPerView: 2,
      spaceBetween: 10,
      centeredSlides: false,
      slidesPerGroupSkip: 1,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  }

  openModal(template: TemplateRef<any>) {
    // this.modalRef = this.modalService.show(template, { class: 'log-reg-ui modal-md' });
    this.modalRef = this.modalService.show(template, { class: 'loginhomemodal' });
  }
  closeModel() {
    this.modalRef.hide();
  }

  openAppMoadal(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.openModal(template);
  }

  openLogin() {
    this._common.openModalWithComponent({ loginFreeplay: true }, LoginPageComponent, 'loginhomemodal')
  }

}
